import React from 'react';
import styles from './styles.module.scss';

export const MenuContainer = ({ children }) => (
  <div className={styles.movingOutInfoMenus}>
    {children}
  </div>
);
